import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "react-admin";
import * as User from "providers/user";

interface Items {
  text: string;
  activeOnUrl: string;
}

interface NestedMenuItemsProps {
  item: Items;
  isDrawerOpen: boolean;
  open: boolean;
  isNestedActive: boolean;
  isActive: boolean;
  fromPopover?: boolean;
  handleClosePopover?: () => void;
  closeDrawer: () => void;
  isSmall: boolean;
  cyId?: string;
  isIpadSizeScreen: boolean;
}

const NestedMenuItems: React.FC<NestedMenuItemsProps> = ({
  isDrawerOpen,
  item,
  isNestedActive,
  open,
  isActive,
  fromPopover,
  handleClosePopover,
  closeDrawer,
  isSmall,
  cyId = "",
  isIpadSizeScreen
}) => {
  const navigate = useNavigate();
  const translate = useTranslate();
  const { setIsNewChargeModalOpen } = User.useUser();

  const handleClick = (): void => {
    if (item.text === "Appointment Calendar") {
      localStorage.removeItem("RaStore.Appointment.listParams");
      localStorage.removeItem("RaStore.AppointmentService.listParams");
    }
    if (fromPopover && handleClosePopover) {
      if (item.activeOnUrl === "open_new_charge_modal") {
        setIsNewChargeModalOpen(true);
      } else {
        navigate(item.activeOnUrl);
      }
      handleClosePopover();
    } else {
      if (isSmall) {
        closeDrawer();
      }
      if (item.activeOnUrl === "open_new_charge_modal") {
        setIsNewChargeModalOpen(true);
      } else {
        navigate(item.activeOnUrl);
      }
    }
  };

  const menuItemsStyles = {
    minWidth: "47px",
    backgroundColor:
      (!isDrawerOpen && isNestedActive) || (!open && isNestedActive)
        ? "rgba(184, 114, 42, 0.08)"
        : "#FAF9F7",
    margin: isDrawerOpen || fromPopover ? "" : "0px 8px",
    borderRadius: open && isDrawerOpen ? "24px 24px 0px 0px" : "24px",
    paddingX: isDrawerOpen || fromPopover ? "" : "12px",
    gap: "-4px",
    paddingY: "6px",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: isIpadSizeScreen ? "14px" : "16px",
    color: "rgba(48, 47, 46, 0.95)",
    paddingRight: fromPopover ? "40px" : "",
    marginBottom: isDrawerOpen || fromPopover ? "" : "4px",
    "&:hover": {
      backgroundColor:
        (!isDrawerOpen && isNestedActive) || (!open && isNestedActive)
          ? "rgba(184, 114, 42, 0.08)"
          : "rgba(0, 0, 0, 0.04)"
    },
    "& svg": {
      fill:
        (!isDrawerOpen && isNestedActive) || (!open && isNestedActive)
          ? "#B8722A"
          : "#D9D9D9",
      "& g": {
        "& path": {
          fill:
            (!isDrawerOpen && isNestedActive) || (!open && isNestedActive)
              ? "#B8722A"
              : "#302F2E",
          fillOpacity:
            (!isDrawerOpen && isNestedActive) || (!open && isNestedActive)
              ? "1"
              : "0.56"
        }
      }
    }
  };
  return (
    <ListItemButton
      onClick={handleClick}
      data-cy={cyId}
      key={item.text}
      sx={{
        ...menuItemsStyles,
        borderRadius: "0px",
        backgroundColor: isActive ? "rgba(184, 114, 42, 0.08)" : "#FAF9F7",
        "&:hover": {
          backgroundColor: isActive
            ? "rgba(184, 114, 42, 0.08)"
            : "rgba(0, 0, 0, 0.04)"
        },
        "&:last-child": {
          borderRadius: fromPopover ? "0px" : "0px 0px 24px 24px"
        }
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: fromPopover ? "36px" : isIpadSizeScreen ? "43px" : "52px"
        }}
      >
        {isActive && (
          <CheckIcon
            style={{
              fill: "#B8722A",
              width: "18px",
              marginLeft: "4px"
            }}
          />
        )}
      </ListItemIcon>
      <ListItemText
        primary={
          <span
            style={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: isIpadSizeScreen ? "14px" : "16px",
              color: isActive ? "#B8722A" : "rgba(48, 47, 46, 0.95)"
            }}
          >
            {translate(`navigation.${item.text}`)}
          </span>
        }
      />
    </ListItemButton>
  );
};

export default NestedMenuItems;
